module.exports = __webpack_public_path__ + "static/media/tco-kalkylatorn_montage.07d444a8.jpg";